export default __webpack_public_path__ + "static/media/torch-dark.224f197f.svg";